import { PhaseBanner } from './PhaseBanner';
import { PhasesAttachments } from '../Strategy/PhasesAttachments';
import { PhaseLinks } from './PhaseLinks';
import { StrategyComments } from './StrategyComments';

export const PhasesTab = ({ userInfoMap, strategyId }) => {
  return (
    <>
      <PhaseBanner />
      <PhasesAttachments userInfoMap={userInfoMap} strategyId={strategyId} />
      <PhaseLinks userInfoMap={userInfoMap} />
      <StrategyComments userInfoMap={userInfoMap} />
    </>
  );
};
